export default __webpack_public_path__ + "static/media/art-slt-banner-3.9222eea3.jpg";